/* ==========================================================================
   THP cart — behaviour for snippets/hp-cart.liquid (drawer + /cart page).

   Every change goes through the Cart AJAX API with the Section Rendering API,
   and each <hp-cart> on the page is swapped for its freshly rendered copy, so
   the numbers always come from Liquid. This file only adds:
     · quantity / remove / discount code / gift & payment attributes
     · estimated arrival dates (client clock)
     · up to 2 suggestions merged across every item in the cart
     · the free-gift sync for reward tiers that carry a gift product
   ========================================================================== */
(function () {
  if (customElements.get('hp-cart')) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var giftSyncing = false;
  var giftFailed = {}; // variant ids that could not be added this visit — never retried in a loop
  var giftRuns = [];
  var recsCache = {};

  function money(cents) {
    return 'Rs ' + Math.round(cents / 100).toLocaleString('en-US');
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Something went wrong');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function allCarts() {
    return Array.prototype.slice.call(document.querySelectorAll('hp-cart'));
  }

  function sectionIds() {
    var ids = ['cart-icon-bubble'];
    allCarts().forEach(function (c) {
      var id = c.dataset.section;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* Replace every <hp-cart> (and the header bubble) with fresh markup. */
  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    allCarts().forEach(function (c) {
      var html = sections[c.dataset.section];
      if (!html) return;
      var fresh = parser.parseFromString(html, 'text/html').querySelector('hp-cart[data-context="' + c.dataset.context + '"]');
      if (!fresh) return;
      // keep what the shopper has open / is typing
      var openPanels = Array.prototype.filter.call(c.querySelectorAll('[data-hp-panel]'), function (p) { return !p.hidden; })
        .map(function (p) { return p.getAttribute('data-hp-panel'); });
      var scroll = c.querySelector('.hp-cart__body');
      var top = scroll ? scroll.scrollTop : 0;
      c.replaceWith(document.importNode(fresh, true));
      var now = document.querySelector('hp-cart[data-context="' + c.dataset.context + '"]');
      if (now) {
        openPanels.forEach(function (name) { setPanel(now, name, true); });
        var s2 = now.querySelector('.hp-cart__body');
        if (s2) s2.scrollTop = top;
      }
    });
    var bubbleHtml = sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var src = parser.parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (src) bubble.innerHTML = src.innerHTML;
    }
  }

  function refresh() {
    var ids = sectionIds();
    return fetch(ROOT + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(applySections);
  }

  function announce(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hp-cart', cartData: cart });
    }
    document.dispatchEvent(new CustomEvent('hp:cart-updated', { detail: cart }));
  }

  function setBusy(on) {
    busy = on;
    allCarts().forEach(function (c) { c.classList.toggle('is-busy', on); });
  }

  /* change a line, re-render everything */
  function changeLine(key, qty, lineEl) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return post(ROOT + 'cart/change.js', { id: key, quantity: qty, sections: sectionIds() })
      .then(function (cart) {
        applySections(cart.sections);
        announce(cart);
      })
      .catch(function (e) {
        var err = lineEl && lineEl.querySelector('.hp-line__error');
        if (err) {
          err.textContent = e.message;
          err.hidden = false;
        }
      })
      .then(function () { setBusy(false); });
  }

  /* ---- "Have a code?" / "Additional details" panels ---- */
  function setPanel(root, name, open) {
    var panel = root.querySelector('[data-hp-panel="' + name + '"]');
    var link = root.querySelector('[data-hp-toggle="' + name + '"]');
    if (!panel) return;
    panel.hidden = !open;
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---- attributes (payment, gift) and the order note ("Additional details") ---- */
  var attrTimer = null;
  var pendingAttrs = {};
  var pendingNote = null;
  function queueNote(value, wait) {
    pendingNote = value;
    return queueAttrs({}, wait);
  }
  function queueAttrs(attrs, wait) {
    Object.keys(attrs).forEach(function (k) { pendingAttrs[k] = attrs[k]; });
    clearTimeout(attrTimer);
    return new Promise(function (resolve) {
      attrTimer = setTimeout(function () { flushAttrs().then(resolve); }, wait == null ? 600 : wait);
    });
  }
  function flushAttrs() {
    clearTimeout(attrTimer);
    var attrs = pendingAttrs;
    var note = pendingNote;
    pendingAttrs = {};
    pendingNote = null;
    var body = {};
    if (Object.keys(attrs).length) body.attributes = attrs;
    if (note !== null) body.note = note;
    if (!Object.keys(body).length) return Promise.resolve();
    return post(ROOT + 'cart/update.js', body).catch(function () {});
  }
  function readAttrs(root) {
    var a = {};
    var pay = root.querySelector('[data-hp-pay]:checked');
    if (pay) a['Payment preference'] = pay.value;
    var gift = root.querySelector('[data-hp-gift]');
    if (gift) {
      var msg = root.querySelector('[data-hp-gift-msg]');
      var hide = root.querySelector('[data-hp-hide-prices]');
      a['Gift'] = gift.checked ? 'Yes' : '';
      a['Gift message'] = gift.checked && msg ? msg.value.trim().slice(0, 160) : '';
      a['Hide prices'] = gift.checked && hide && hide.checked ? 'Yes' : '';
    }
    return a;
  }

  /* ---- discount codes ---- */
  function currentCodes(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-hp-code-remove]'), function (b) {
      return b.getAttribute('data-hp-code-remove');
    });
  }
  function setCodes(root, codes, typed) {
    if (busy) return;
    setBusy(true);
    post(ROOT + 'cart/update.js', { discount: codes.join(','), sections: sectionIds() })
      .then(function (cart) {
        applySections(cart.sections);
        announce(cart);
        if (typed) {
          var ok = (cart.discount_codes || []).some(function (d) {
            return d.code.toLowerCase() === typed.toLowerCase() && d.applicable;
          });
          var fresh = document.querySelector('hp-cart[data-context="' + root.dataset.context + '"]');
          var msg = fresh && fresh.querySelector('[data-hp-code-msg]');
          if (msg && !ok) {
            msg.textContent = 'That code can’t be used on this cart.';
            msg.hidden = false;
          }
        }
      })
      .catch(function (e) {
        var msg = root.querySelector('[data-hp-code-msg]');
        if (msg) {
          msg.textContent = e.message;
          msg.hidden = false;
        }
      })
      .then(function () { setBusy(false); });
  }

  /* ---- free gifts: make the cart hold exactly the gifts its tiers earn ---- */
  function syncGifts(root) {
    if (giftSyncing || busy) return;
    var want = {};
    (root.dataset.giftWant || '').split(',').forEach(function (pair) {
      if (!pair) return;
      var p = pair.split(':');
      want[p[0]] = p[1];
    });
    var have = {};
    var fixes = [];
    root.querySelectorAll('.hp-line--gift').forEach(function (line) {
      var v = line.getAttribute('data-gift-variant');
      if (!want[v] || have[v]) fixes.push({ id: line.getAttribute('data-key'), quantity: 0 });
      else if (line.getAttribute('data-qty') !== '1') fixes.push({ id: line.getAttribute('data-key'), quantity: 1 });
      have[v] = true;
    });
    var adds = Object.keys(want).filter(function (v) { return !have[v] && !giftFailed[v]; });
    if (!fixes.length && !adds.length) return;
    // hard stop against any ping-pong: at most 4 syncs in 20 seconds
    var now = Date.now();
    giftRuns = giftRuns.filter(function (t) { return now - t < 20000; });
    if (giftRuns.length >= 4) return;
    giftRuns.push(now);

    giftSyncing = true;
    var chain = Promise.resolve();
    fixes.forEach(function (f) {
      chain = chain.then(function () { return post(ROOT + 'cart/change.js', f); });
    });
    if (adds.length) {
      chain = chain.then(function () {
        return post(ROOT + 'cart/add.js', {
          items: adds.map(function (v) {
            return {
              id: Number(v),
              quantity: 1,
              properties: { _hp_gift: 'Reward ' + (Number(want[v]) + 1) },
            };
          }),
        }).catch(function (e) {
          adds.forEach(function (v) { giftFailed[v] = true; });
          throw e;
        });
      });
    }
    chain
      .catch(function () {})
      .then(refresh)
      .then(function (r) {
        giftSyncing = false;
        return r;
      }, function () { giftSyncing = false; });
  }

  /* ---- Snap Cart Drawer leftovers ----
     Snap's drawer writes eward, cartId, uthor and marketId onto the
     cart, and its discount then applies whatever reward Snap's own server last
     worked out for that cart — not what is in it now (seen: 10% off on a
     Rs 55,545 cart after it had been over Rs 80,000). This cart does not use
     Snap, so it clears them once; nothing re-adds them unless Snap's drawer
     runs again. */
  var snapCleared = false;
  function clearSnapState(root) {
    if (snapCleared || !root.hasAttribute('data-snap-state')) return;
    snapCleared = true;
    post(ROOT + 'cart/update.js', { attributes: { reward: '', cartId: '', author: '', marketId: '' } })
      .then(refresh)
      .catch(function () {});
  }

  /* ---- arrival dates ---- */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmtDate(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function renderEta(root) {
    var el = root.querySelector('[data-hp-eta]');
    if (!el) return;
    var min = parseInt(root.dataset.etaMin, 10) || 3;
    var max = Math.max(min, parseInt(root.dataset.etaMax, 10) || 6);
    var dispatch = addDays(new Date(), 1);
    if (dispatch.getDay() === 0) dispatch = addDays(dispatch, 1);
    el.querySelector('[data-hp-eta-range]').textContent = fmtDate(addDays(dispatch, min)) + ' – ' + fmtDate(addDays(dispatch, max));
    el.hidden = false;
  }

  /* ---- suggestions: at most N, merged across every cart item ----
     Score: curated pairing 3 (+ a little for its position), Shopify
     "complementary" 2, "related" 1 — summed, so a product suggested for
     several items in the cart ranks first. In-cart products never show. */
  function fetchRecs(productId, intent) {
    var key = intent + ':' + productId;
    if (recsCache[key]) return recsCache[key];
    var stored = null;
    try { stored = sessionStorage.getItem('hp-recs:' + key); } catch (e) {}
    if (stored) {
      try {
        recsCache[key] = Promise.resolve(JSON.parse(stored));
        return recsCache[key];
      } catch (e) {}
    }
    recsCache[key] = fetch(ROOT + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) { return p.available; }).map(function (p) {
          var single = p.variants && p.variants.length === 1;
          var img = p.featured_image || (p.images && p.images[0]) || null;
          if (img && typeof img === 'object') img = img.src;
          return {
            id: p.id,
            title: p.title,
            url: p.url,
            price: p.price,
            compare: p.compare_at_price || 0,
            image: img,
            variant: single && p.variants[0].available ? p.variants[0].id : null,
          };
        });
        try { sessionStorage.setItem('hp-recs:' + key, JSON.stringify(list)); } catch (e) {}
        return list;
      })
      .catch(function () { return []; });
    return recsCache[key];
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    try {
      var u = new URL(src, location.origin);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return src; }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderRecs(root) {
    var box = root.querySelector('[data-hp-recs]');
    var n = parseInt(root.dataset.recsCount, 10) || 0;
    if (!box || n < 1) return;
    var inCart = (root.dataset.inCart || '').split(',').filter(Boolean).map(Number);
    var giftVariants = (root.dataset.giftWant || '').split(',').filter(Boolean).map(function (p) { return Number(p.split(':')[0]); });
    var sources = (root.dataset.sourceIds || '').split(',').filter(Boolean).map(Number);
    var productIds = sources.filter(function (id, i) { return sources.indexOf(id) === i; }).slice(0, 4);

    var scores = {};
    var info = {};
    function score(p, pts) {
      if (inCart.indexOf(p.id) !== -1) return;
      if (p.variant && giftVariants.indexOf(p.variant) !== -1) return;
      scores[p.id] = (scores[p.id] || 0) + pts;
      if (!info[p.id]) info[p.id] = p;
    }

    var curated = [];
    try { curated = JSON.parse((root.querySelector('[data-hp-curated]') || {}).textContent || '[]'); } catch (e) {}
    curated.forEach(function (p) { score(p, 3 + Math.max(0, 0.5 - p.rank * 0.05)); });

    var jobs = [];
    productIds.forEach(function (id) {
      jobs.push(fetchRecs(id, 'complementary').then(function (l) { l.forEach(function (p, i) { score(p, 2 + Math.max(0, 0.3 - i * 0.05)); }); }));
      jobs.push(fetchRecs(id, 'related').then(function (l) { l.forEach(function (p, i) { score(p, 1 + Math.max(0, 0.3 - i * 0.05)); }); }));
    });

    Promise.all(jobs).then(function () {
      if (!root.isConnected) return;
      var ids = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; }).slice(0, Math.min(n, 2));
      var list = box.querySelector('[data-hp-recs-list]');
      if (!ids.length) {
        box.hidden = true;
        return;
      }
      list.innerHTML = ids.map(function (id) {
        var p = info[id];
        var price = '<span class="hp-crec__price">' + money(p.price) + '</span>';
        if (p.compare && p.compare > p.price) price += ' <s>' + money(p.compare) + '</s>';
        var action = p.variant
          ? '<button type="button" class="hp-crec__add" data-hp-add="' + p.variant + '">Add</button>'
          : '<a class="hp-crec__add" href="' + esc(p.url) + '">View</a>';
        return (
          '<div class="hp-crec">' +
          '<a class="hp-crec__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(imgUrl(p.image, 160)) + '" alt="" width="64" height="80" loading="lazy">' : '') +
          '</a>' +
          '<div class="hp-crec__info"><a class="hp-crec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<p class="hp-crec__prices">' + price + '</p></div>' +
          action +
          '</div>'
        );
      }).join('');
      box.hidden = false;
    });
  }

  function addVariant(btn) {
    if (busy) return;
    setBusy(true);
    btn.disabled = true;
    post(ROOT + 'cart/add.js', { items: [{ id: Number(btn.getAttribute('data-hp-add')), quantity: 1 }], sections: sectionIds() })
      .then(function (res) {
        applySections(res.sections);
        announce(res);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Unavailable';
      })
      .then(function () { setBusy(false); });
  }

  /* ---- confetti when a reward is unlocked ----
     Liquid writes data-rb-reached (rewards unlocked right now). The last count
     seen is kept for the visit, so the burst fires only when it goes UP — not
     on page load, not on the re-render after a gift is added, and only once
     when the drawer and /cart page both re-render. No library: one canvas,
     ~2.5 s, then removed. Skipped for prefers-reduced-motion. */
  var RB_KEY = 'hp-rb-reached';
  var rbSeen = null;
  function readSeen() {
    try { var v = sessionStorage.getItem(RB_KEY); if (v !== null) return parseInt(v, 10); } catch (e) {}
    return rbSeen;
  }
  function writeSeen(n) {
    rbSeen = n;
    try { sessionStorage.setItem(RB_KEY, String(n)); } catch (e) {}
  }
  function checkReward(root) {
    var n = parseInt(root.dataset.rbReached || '0', 10);
    if (isNaN(n)) return;
    var drawer = root.closest('cart-drawer');
    // on /cart the hidden drawer re-renders too — leave the count to the visible cart
    if (drawer && !drawer.classList.contains('active') && document.querySelector('hp-cart[data-context="page"]')) return;
    var before = readSeen();
    writeSeen(n);
    if (before === null || isNaN(before) || n <= before) return;
    // a closed drawer re-rendering in the background is not a moment to celebrate
    if (drawer && !drawer.classList.contains('active')) {
      // product-form.js opens the drawer right after refilling it — try once more then
      setTimeout(function () { if (drawer.classList.contains('active')) confetti(root); }, 350);
      return;
    }
    confetti(root);
  }
  function confetti(root) {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var origin = root.querySelector('.hp-rb__track') || root;
      var box = origin.getBoundingClientRect();
      var ox = box.width ? box.left + box.width / 2 : window.innerWidth / 2;
      var oy = box.height || box.top ? box.top + box.height / 2 : window.innerHeight / 3;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var cv = document.createElement('canvas');
      cv.setAttribute('aria-hidden', 'true');
      cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000';
      cv.width = Math.round(window.innerWidth * dpr);
      cv.height = Math.round(window.innerHeight * dpr);
      document.body.appendChild(cv);
      var ctx = cv.getContext('2d');
      ctx.scale(dpr, dpr);
      var colors = ['#1a4b46', '#2f7d74', '#f6c48f', '#c4622d', '#e0a422', '#fff9df'];
      var parts = [];
      for (var i = 0; i < 110; i++) {
        var a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.95;
        var v = 6 + Math.random() * 9;
        parts.push({
          x: ox + (Math.random() - 0.5) * Math.min(box.width || 120, 260),
          y: oy,
          vx: Math.cos(a) * v,
          vy: Math.sin(a) * v - 2,
          w: 5 + Math.random() * 5,
          h: 3 + Math.random() * 4,
          r: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.35,
          round: Math.random() < 0.3,
          c: colors[i % colors.length],
        });
      }
      var start = performance.now();
      var LIFE = 2600;
      (function frame(now) {
        var t = now - start;
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        var fade = t > LIFE - 600 ? Math.max(0, (LIFE - t) / 600) : 1;
        ctx.globalAlpha = fade;
        parts.forEach(function (p) {
          p.vx *= 0.985;
          p.vy = p.vy * 0.985 + 0.32;
          p.x += p.vx;
          p.y += p.vy;
          p.r += p.vr;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.r);
          ctx.fillStyle = p.c;
          if (p.round) {
            ctx.beginPath();
            ctx.arc(0, 0, p.h / 1.4, 0, Math.PI * 2);
            ctx.fill();
          } else {
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r * 2)) + 1);
          }
          ctx.restore();
        });
        if (t < LIFE) requestAnimationFrame(frame);
        else cv.remove();
      })(start);
      // safety net if animation frames are paused (background tab)
      setTimeout(function () { if (cv.isConnected) cv.remove(); }, LIFE + 1500);
    } catch (e) { /* a celebration is never worth an error */ }
  }

  class HpCart extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var root = this;

      this.addEventListener('click', function (e) {
        var q = e.target.closest('[data-hp-qty]');
        if (q && !q.disabled) {
          var line = q.closest('.hp-line');
          changeLine(line.getAttribute('data-key'), parseInt(q.getAttribute('data-hp-qty'), 10), line);
          return;
        }
        var toggle = e.target.closest('[data-hp-toggle]');
        if (toggle) {
          var name = toggle.getAttribute('data-hp-toggle');
          var opening = toggle.getAttribute('aria-expanded') !== 'true';
          setPanel(root, name, opening);
          if (opening) {
            var field = root.querySelector('[data-hp-panel="' + name + '"] input, [data-hp-panel="' + name + '"] textarea');
            if (field) field.focus();
          }
          return;
        }
        var add = e.target.closest('[data-hp-add]');
        if (add) {
          addVariant(add);
          return;
        }
        if (e.target.closest('[data-hp-code-apply]')) {
          var input = root.querySelector('[data-hp-code]');
          var code = input && input.value.trim();
          if (!code) return;
          var codes = currentCodes(root);
          if (codes.indexOf(code) === -1) codes.push(code);
          setCodes(root, codes, code);
          return;
        }
        var rm = e.target.closest('[data-hp-code-remove]');
        if (rm) {
          var drop = rm.getAttribute('data-hp-code-remove');
          setCodes(root, currentCodes(root).filter(function (c) { return c !== drop; }));
        }
      });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-hp-code]')) {
          e.preventDefault();
          var btn = root.querySelector('[data-hp-code-apply]');
          if (btn) btn.click();
        }
      });

      this.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-hp-pay]')) {
          root.querySelectorAll('.hp-opt').forEach(function (o) { o.classList.toggle('is-on', o.contains(t)); });
          queueAttrs(readAttrs(root), 0);
        } else if (t.matches('[data-hp-gift]')) {
          var box = root.querySelector('.hp-giftbox');
          box.classList.toggle('is-on', t.checked);
          box.querySelector('.hp-giftbox__fields').hidden = !t.checked;
          if (t.checked) {
            var ta = box.querySelector('textarea');
            if (ta) ta.focus();
          }
          queueAttrs(readAttrs(root), 0);
        } else if (t.matches('[data-hp-hide-prices]')) {
          queueAttrs(readAttrs(root), 0);
        }
      });

      this.addEventListener('input', function (e) {
        if (e.target.matches('[data-hp-gift-msg]')) {
          var c = root.querySelector('[data-hp-gift-count]');
          if (c) c.textContent = e.target.value.length + '/160';
          queueAttrs(readAttrs(root), 800);
        } else if (e.target.matches('[data-hp-note]')) {
          queueNote(e.target.value, 800);
        }
      });

      var form = this.querySelector('.hp-cart__form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = root.querySelector('[data-hp-checkout]');
          if (btn) btn.classList.add('is-loading');
          var noteField = root.querySelector('[data-hp-note]');
          if (noteField) pendingNote = noteField.value;
          queueAttrs(readAttrs(root), 0).then(function () {
            window.location.href = ROOT + 'checkout';
          });
        });
      }

      // mark the chosen payment card
      var checked = this.querySelector('[data-hp-pay]:checked');
      if (checked) checked.closest('.hp-opt').classList.add('is-on');

      renderEta(this);
      renderRecs(this);
      checkReward(this);
      clearSnapState(this);
      // a moment later, so a burst of re-renders only syncs once
      setTimeout(function () { if (root.isConnected) syncGifts(root); }, 50);

      var drawer = this.closest('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
    }
  }
  customElements.define('hp-cart', HpCart);

  // anything else that changes the cart (quick add, product form) — refresh
  function listen() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'hp-cart') return;
        refresh();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen);
  else listen();

  // back/forward cache can show a stale cart
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
